
import BarcodeSymbologiesSelection from '@/components/BarcodeSymbologiesSelection.vue'
import LocationScan from '@/components/LocationScan.vue'
import ScanArea from '@/components/svg/ScanArea.vue'
import { Options, Vue } from 'vue-class-component'
import { PropSync, Prop } from 'vue-property-decorator'

@Options({
  components: {
    ScanArea,
    BarcodeSymbologiesSelection,
    LocationScan,
  },
  emits: ['validate:locationId', 'update:isShow'],
  name: 'LocationScanDialog',
})
export default class LocationScanDialog extends Vue {
  @Prop({ type: String }) readonly operationType?: string
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean

  closeLocationScanDialog() {
    this._isShow = false
  }

  handleScanResult(text: string) {
    this.$emit('validate:locationId', text)
  }
}
